import { render, staticRenderFns } from "./BoxActions.vue?vue&type=template&id=84d64f6a&scoped=true&"
import script from "./BoxActions.vue?vue&type=script&lang=js&"
export * from "./BoxActions.vue?vue&type=script&lang=js&"
import style0 from "./BoxActions.vue?vue&type=style&index=0&id=84d64f6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d64f6a",
  null
  
)

export default component.exports